// extracted by mini-css-extract-plugin
module.exports = {"quantityModifier":"CartItemQuantityWidget_quantityModifier__WKGP4"};